<template lang="pug">
    .outer-wrapper(:class="'context-'+context")
        include HomeTrainers.pug
</template>

<script>
import Api from "@/components/services/Api";
import Trainer from "@/components/Trainer";
import { mapState } from 'vuex';

export default {
    name: 'HomeTrainers',
    components: {Trainer},
    computed: mapState([
        "context",
    ]),
    data() {
        return {
            trainers: [],
        };
    },
    created() {
        const _this = this;
        this.search();
    },
    methods: {
        search() {
            const _this = this;

            let filters = {};
            filters.page = 1;

            Api.getTrainerList(filters).then(response => {
                _this.trainers = response.data.items;
            }).catch();
        },
    }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";

@import "HomeTrainers";

.context-colreps {
    @import "HomeTrainersColreps";
}
</style>



// WEBPACK FOOTER //
// src/components/home_trainers/HomeTrainers.vue